module.exports = __webpack_public_path__ + "img/blockAB22.ddd88eb7.svg";